import {
  generateGoogleCalendarUrl,
  generateOutlookCalendarUrl,
  generateYahooCalendarUrl,
} from '@shared/core/add-to-calendar'
import { useCallback } from 'react'
import { downloadICSFile } from 'src/modules/booking/utils/calendar-helpers'
import type { AddToCalendarProps, CalendarOptionType } from './add-to-calendar.interface'

export function useAddToCalendar({ calendarEventData }: AddToCalendarProps) {
  const handleCalendarClick = useCallback(
    (type: CalendarOptionType) => {
      if (!calendarEventData) return
      switch (type) {
        case 'google':
          window.open(generateGoogleCalendarUrl(calendarEventData), '_blank', 'noopener,noreferrer')
          break
        case 'outlook':
          window.open(generateOutlookCalendarUrl(calendarEventData), '_blank', 'noopener,noreferrer')
          break
        case 'yahoo':
          window.open(generateYahooCalendarUrl(calendarEventData), '_blank', 'noopener,noreferrer')
          break
        case 'ics':
          downloadICSFile(calendarEventData)
          break
      }
    },
    [calendarEventData],
  )

  return {
    calendarEventData,
    handleCalendarClick,
  }
}
